import React, { useCallback, useRef, useState } from 'react'
import styled from 'styled-components'
import { IMaskInput } from 'react-imask'
import { _prefixContactPhone, formConfig } from './config'
import options from '../PrefixPhoneSelect/prefix.json'
import { ErrorMessage, Field } from 'formik'
import { formComponentDefaultStyles } from '../../../styles/defaults'
import FormErrorMessage from '../FormErrorMessage'

const StyledInput = styled(IMaskInput)`
  ${formComponentDefaultStyles};
`

const InputBlock = styled.div`
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;

  & > * {
    width: 100%;
  }
`

const InputWrap = styled.div`
  position: relative;
  z-index: 0;
  order: -1;
`

const placeholderByMask = mask =>
  mask ? mask.replaceAll('0', 'X').replace(/[{}]/g, '') : 'XXX-XXX-XXXX'

const PhoneInput = ({ field, form, ...props }) => {
  const inputRef = useRef(null)
  const [isFieldTouched, setIsFieldTouched] = useState(false)
  const prefix = options.find(
    option => option.value === form.values[_prefixContactPhone]
  )

  const fieldName = field.name

  const onAccept = useCallback(
    value => {
      form.setFieldValue(fieldName, value)
    },
    [fieldName]
  )

  const onBlur = useCallback(() => {
    if (!isFieldTouched) {
      form.setFieldTouched(fieldName, true)
      setIsFieldTouched(true)
    }
  }, [isFieldTouched])

  const inputProps = {
    ...props,
    name: fieldName,
    placeholder: placeholderByMask(prefix?.mask),
    type: 'phone',
    required: true,
    mask: prefix?.mask || '000-000-0000',
    unmask: true,
    onAccept: onAccept,
    onChange: () => {},
    onBlur,
    ref: inputRef,
  }

  return (
    <InputBlock className="contact-phone__number">
      <ErrorMessage component={FormErrorMessage} name={fieldName} />
      <InputWrap>
        <StyledInput {...inputProps} />
      </InputWrap>
    </InputBlock>
  )
}

const PhoneInputWrapper = ({ name }) => (
  <>
    <Field
      name={formConfig[name].name}
      type={formConfig[name].type}
      placeholder={
        formConfig[name].placeholder || `Enter ${formConfig[name].label}`
      }
      component={PhoneInput}
    />
  </>
)

export default PhoneInputWrapper
